import React from "react";
import { FeatureCheck } from "./ui/feature-check";

export interface FeatureListProps {
  features: { feature: string }[];
}

export const FeatureList = ({ features }: FeatureListProps) => {
  return (
    <ul className="block flex flex-col gap-2">
      {features.map((f, i) => (
        <li key={i} className="flex items-center gap-2">
          <FeatureCheck />
          {f.feature}
        </li>
      ))}
    </ul>
  );
};
